import React from "react";
import styles from "./RegularCategory.module.css";
import ParticipationProcess from "./ParticipationProcess";
import CategoryTables from "./CategoryTables";
import CoreValues from "./CoreValues";
import Rewards from "./Rewards";
import HardwareSoftware from "./HardwareSoftware";
import Partners from "./Partners";

const RegularCategory = () => {
  return (
    <div className={styles.openCategory}>
      <ParticipationProcess />
      <CategoryTables />
      <CoreValues />
      <Rewards />
      <HardwareSoftware />
      <Partners />
    </div>
  );
};

export default RegularCategory;
